import {
  login,
  logout,
  getUserInfo
} from '@/api/user'
import { resetRouter } from '@/router'
import { setToken, getToken } from '@/libs/util'
import { filterAsyncRouter } from '@/libs/router-utils'

export default {
  state: {
    userInfo: {},
    token: getToken()
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    }
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { username, password, googlepass }) {

      username = username.trim()
      return new Promise((resolve, reject) => {
       
        login({ username, password,googlepass }).then(res => {
          // 调试：打印响应数据
          console.log('登录响应数据:', res)
          
          // 检查返回数据结构
          // res 是 {data: {...}, status: 200}
          // res.data 是后端返回的完整响应 {success: true, msg: '', code: 1, data: {...}}
          // res.data.data 才是真正的用户数据
          if (!res || !res.data) {
            console.error('响应数据格式错误:', res)
            reject(new Error('登录返回数据格式错误：缺少data字段'))
            return
          }
          
          // 检查后端返回的success字段
          if (res.data.success === false) {
            reject(new Error(res.data.msg || '登录失败'))
            return
          }
          
          // 检查是否有data字段
          if (!res.data.data) {
            console.error('响应数据格式错误:', res.data)
            reject(new Error('登录返回数据格式错误：缺少data.data字段'))
            return
          }
          
          const userData = res.data.data
          console.log('用户数据:', userData)
          
          // titlePrefix 必须在 filterAsyncRouter 之前写入，因为 filterAsyncRouter 内部会读 localStorage
          if (userData.titlePrefix) {
            window.localStorage.setItem('titlePrefix', userData.titlePrefix)
          }

          // 先校验 token 字段，缺失直接 reject，避免出现 "已 setUserInfo 但无 token" 的中间态
          if (!userData.apiAuth) {
            console.warn('登录返回数据中没有apiAuth字段')
            reject(new Error('登录返回数据中缺少apiAuth字段'))
            return
          }

          // 顺序很重要（修复"登录后菜单空白，刷新才出来"）：
          //   1) setUserInfo / setToken 先 commit，让 userInfo.access 在
          //      menuList getter 第一次被读取时就已就位（getter 依赖 rootState.user.userInfo.access）
          //   2) 再 setItem(dynamicRouter) 持久化，给 router beforeEach 的兜底恢复用
          //   3) 最后 commit updateMenuList，触发 router.addRoutes 并设置 state.menuList
          //      这一步发生时所有依赖项都已就绪，主框架 main.vue 第一次渲染就拿到非空菜单。
          commit('setUserInfo', userData)
          commit('setToken', userData.apiAuth)

          if (userData.menu && Array.isArray(userData.menu)) {
            sessionStorage.setItem('dynamicRouter', JSON.stringify(userData.menu))
            commit('updateMenuList', filterAsyncRouter(userData.menu))
          } else {
            console.warn('登录返回数据中没有menu字段或menu不是数组，使用空菜单')
            sessionStorage.setItem('dynamicRouter', JSON.stringify([]))
            commit('updateMenuList', [])
          }

          resolve()
        }).catch(err => {
          console.error('登录错误:', err)
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('setToken', '')
          commit('setUserInfo', {})
          resetRouter()
          sessionStorage.removeItem('dynamicRouter')
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取用户相关信息
    getUserInfo ({ state, commit }) {
      if (JSON.stringify(state.userInfo) !== '{}') {
        return Promise.resolve(state.userInfo)
      } else {
        return new Promise((resolve, reject) => {
          try {
            getUserInfo().then(res => {
              commit('setUserInfo', res.data.data)
              resolve(res.data.data)
            }).catch(err => {
              console.error('getUserInfo API错误:', err)
              reject(err)
            })
          } catch (error) {
            console.error('getUserInfo 异常:', error)
            reject(error)
          }
        })
      }
    }
  }
}
